function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PaginationBasic from '@/components/PaginationBasic.vue';
import UserSettingsService from '@/apps/data-platform/services/security/user_settings_service';
import { envConfig } from '@/js/constants';
import utils from '@/js/utils';
export default {
  name: 'MyNotificationsPage',
  components: {
    PaginationBasic: PaginationBasic
  },
  data: function data() {
    return {
      items: [],
      pagination: {
        current: 1,
        limit: envConfig.pagintaionSize,
        total: 0,
        offset: 0
      },
      key_table: 1
    };
  },
  created: function created() {
    this.getNotifications();
  },
  methods: {
    itemClass: function itemClass(item) {
      console.log(item.read);
      return {
        'white lighten-4': item.read,
        'font-weight-bold': !item.read
      };
    },
    onClickNotification: function onClickNotification(notification) {
      var _this = this;
      var notificationId = notification.document_id;
      if (notification.link) {
        window.open(notification.link, '_blank');
      } else if (notification.path) {
        this.$router.push({
          path: notification.path
        });
      }
      if (!notification.read) {
        var data = {
          dataUpdate: {
            read: true
          }
        };
        UserSettingsService.updateNotification(this.userEmail, notificationId, data).then(function (response) {
          _this.getUserNotifications();
        });
      }
    },
    getNotifications: function getNotifications() {
      var _this2 = this;
      this.$store.commit('app/setShowLoading', true);
      this.params = {
        pagination: utils.cloneJSON(this.pagination)
      };
      this.params.pagination.limit++;
      UserSettingsService.getUserNotifications(this.userEmail, this.params).then(function (response) {
        _this2.items = response.data;
        console.log(_this2.items);
        if (_this2.items.length === _this2.pagination.limit + 1) {
          _this2.items.splice(_this2.items.length - 1);
          _this2.pagination.next = true;
          _this2.pagination.total = _this2.pagination.limit;
        } else {
          _this2.pagination.next = false;
          _this2.pagination.total = _this2.pagination.limit - 1;
        }
        _this2.$store.commit('app/setShowLoading', false);
      });
    },
    changePage: function changePage(currentPage) {
      this.pagination.current = currentPage;
      this.pagination.offset = (this.pagination.current - 1) * this.pagination.limit;
      this.getNotifications();
    }
  },
  computed: {
    headers: function headers() {
      return [{
        text: this.translate('table_notifications.title'),
        value: 'title'
      }, {
        text: this.translate('table_notifications.description'),
        value: 'description'
      }, {
        text: this.translate('table_notifications.created_date'),
        value: 'created'
      }, {
        text: this.translate('table_notifications.created_by'),
        value: 'created_by'
      }, {
        text: this.translate('table_notifications.actions'),
        value: 'actions'
      }];
    },
    notifications: function notifications() {
      var _this3 = this;
      return this.items.map(function (item) {
        var created = _this3.$moment(new Date(item.created)).format('DD/MM/YYYY HH:mm:ss');
        return _objectSpread(_objectSpread({}, item[_this3.$i18n.locale]), {}, {
          created: created,
          created_by: item.created_by || 'INCA',
          path: item.path,
          read: item.read,
          document_id: item.document_id
        });
      });
    }
  }
};